import {Login} from '@/security/components'
import {Menu, Layout} from '@/macarons/components'

export default {
  axios: {
    baseURL: window[window.macarons].back
  },
  colnum: 12,
  rowheight: 10,
  useCssTransform: false,
  baseWidgetWidth: 4,
  baseWidgetHeight: 30,
  login: Login,
  menu: Menu,
  layout: Layout
}



// WEBPACK FOOTER //
// ./src/conf.js